import { render, staticRenderFns } from "./PublishField.vue?vue&type=template&id=019d0fd6&scoped=true"
import script from "./PublishField.vue?vue&type=script&lang=js"
export * from "./PublishField.vue?vue&type=script&lang=js"
import style0 from "./PublishField.vue?vue&type=style&index=0&id=019d0fd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d0fd6",
  null
  
)

export default component.exports